// @ts-ignore
import StringMask from "string-mask";

const plateFormatter = new StringMask("AAA-AAAA");

export function formatPlate(placa: string) {
  return plateFormatter.apply(placa);
}
